import { Injectable } from '@angular/core';
import { LatLng } from 'leaflet';
import { Observable } from 'rxjs';
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class LorenUserLocationService {
  public static defaultLocation = new LatLng(42.6048854, 25.6196093);

  private getCurrentPositionAsync(options?: PositionOptions) {
    return new Observable<GeolocationPosition>((subscriber) => {
      if (!('geolocation' in navigator)) {
        subscriber.error(new Error('Geolocation not supported'));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          subscriber.next(pos);
          subscriber.complete();
        },
        (err) => subscriber.error(err),
        options
      );
    });
  }


  getLocation(): Observable<LatLng> {
    return this.getCurrentPositionAsync().pipe(
      map(position => new LatLng(position.coords.latitude, position.coords.longitude)),
      catchError(async () => LorenUserLocationService.defaultLocation),
    )
  }
}
